import React from "react";
import { Switch, BrowserRouter as MainRouter, Route } from "react-router-dom"
import About from "./About";
import App from "./App";
import Contact from "./Contact";
import Restaurant from "./demo/Restaurant.js";
import Feedback from "./Feedback";
import PageNotFound from "./PageNotFound";
import Resume from "./Resume";
import Service from "./Service";
import ColorConversion from "./Services/ColorConversion";
import ColorPicker from "./Services/ColorPicker";
import CurrencyComparison from "./Services/CurrencyComparison";
import Demo from "./Services/Demo";
import Faker from "./Services/Faker";
import GithubUser from "./Services/GithubUser";
import MailValidator from "./Services/MailValidator";
import MovieDetails from "./Services/MovieDetails";
import News from "./Services/News";
import PasswordGenerator from "./Services/PasswordGenerator";
import Skills from "./Skills";
import AdminSignIn from "./Admin/pages/AdminSignIn"
import Home from "./Admin/pages/Home"
import Feedbacks from "./Admin/pages/Feedbacks"


function Router() {
    return (
        <MainRouter>
            <Switch>
                <Route exact path="/" component={App}></Route>
                <Route exact path="/about" component={About}></Route>
                <Route exact path="/skills" component={Skills}></Route>
                <Route exact path="/resume" component={Resume}></Route>
                <Route exact path="/service" component={Service}></Route>
                <Route exact path="/service/faker" component={Faker}></Route>
                <Route exact path="/service/news" component={News}></Route>
                <Route exact path="/service/github-user" component={GithubUser}></Route>
                <Route exact path="/service/movies" component={MovieDetails}></Route>
                <Route exact path="/service/currency-comparison" component={CurrencyComparison}></Route>
                <Route exact path="/service/mail-validator" component={MailValidator}></Route>
                <Route exact path="/service/color-picker" component={ColorPicker}></Route>
                <Route exact path="/service/color-conversion" component={ColorConversion}></Route>
                <Route exact path="/service/password-generator" component={PasswordGenerator}></Route>
                <Route exact path="/contact" component={Contact}></Route>
                <Route exact path="/feedback" component={Feedback}></Route>
                <Route exact path="/service/demo" component={Demo}></Route>
                <Route exact path="/service/demo/restaurant" component={Restaurant}></Route>
                <Route exact path="/v1/admin" component={AdminSignIn}></Route>
                <Route exact path="/v1/admin/home" component={Home}></Route>
                <Route exact path="/v1/admin/feedbacks" component={Feedbacks}></Route>
                <Route component={PageNotFound}></Route>
            </Switch>
        </MainRouter>
    )
}

export default Router
